import Api from './Api';

class PautaApi extends Api {
    async gerarResumoPauta(idSessao, cpfSignatario, sistemaOrigem) {
        const paramSistemaOrigem = sistemaOrigem ? `&sistemaOrigem=${sistemaOrigem}` : '';
        let result = await this.fetch(
            this.configuracao.urlPautas +
                '/' +
                idSessao +
                '/resumo-texto?cpfSignatario=' +
                cpfSignatario +
                paramSistemaOrigem,
            'GET',
            null,
            [{ parametro: 'Accept', valor: 'text/plain' }],
            'blob'
        );
        return result.data;
    }
}

export default PautaApi;
